interface Props {
    url: string;
}
export default function YoutubeIntegration({ url }: Props) {
    const embedUrl = "https://www.youtube-nocookie.com/embed/" + url.split("v=")[1].split("&")[0];
    return (
        <iframe width="560" height="315" src={embedUrl} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen>
        </iframe>
    );
}